<script setup lang="ts">
import type { ResponsiveImageType } from "vue-datocms";
import type { EventRecord, ImageFileField } from "~~/server/graphql/datocms/generated";
import { Image as DatocmsImage } from "vue-datocms";

defineProps<{ event: EventRecord }>();

const localePath = useLocalePath();
</script>

<template>
  <div class="stretched-link-card p-lg group h-full rounded-sm bg-white">
    <div class="mb-lg overflow-hidden">
      <DatocmsImage
        v-if="event.teaserImage as ImageFileField" :data="event.teaserImage.responsiveImage as ResponsiveImageType"
        :fade-in-duration="0" :use-placeholder="false"
        class="transition-transform duration-300 ease-in-out group-hover:scale-105"
      />
    </div>

    <div class="flex flex-col justify-between">
      <div class="md:h-32">
        <h5 class="mb-md">
          {{ event.title }}
        </h5>

        <div class="line-clamp-3" v-html="event.teaserText" />
      </div>

      <NuxtLink :to="localePath({ name: 'events-slug', params: { slug: event.slug } })" class="text-primary underline">
        {{ event.teaserLinkText }}
      </NuxtLink>
    </div>
  </div>
</template>

<style scoped>

</style>
